// Booking App Entry Point
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('.rll-booking-app-container');
    
    containers.forEach(container => {
        const root = createRoot(container);
        root.render(<App />);
    });
});
